import { api } from "@/lib/apiClient";
import type { DokumentTyp } from "@/lib/dokumente";

export type GdEmailVorlageTyp = DokumentTyp | "angebot_nachfass";

export interface GdEmailVorlage {
  dokument_typ: GdEmailVorlageTyp | string;
  subject: string;
  body_html: string;
  updated_by?: string | null;
  updated_at?: string | null;
}

export const DEFAULT_GD_EMAIL_SUBJECT =
  "{{Dokument.typ}} {{Dokument.nummer}} – {{Dokument.betreff}}";

export const DEFAULT_GD_EMAIL_BODY = [
  "<p>{{Ansprechpartner.briefanrede}}</p>",
  "<p>anbei erhalten Sie unser {{Dokument.typ}} <strong>{{Dokument.nummer}}</strong>.</p>",
  "<p>Bei Rückfragen stehen wir Ihnen gerne zur Verfügung.</p>",
  "<p>Mit freundlichen Grüßen</p>",
  "{{Signatur}}",
].join("");

export const DEFAULT_ANGEBOT_NACHFASS_SUBJECT =
  "Erinnerung: {{Dokument.typ}} {{Dokument.nummer}} – {{Dokument.betreff}}";

export const DEFAULT_ANGEBOT_NACHFASS_BODY = [
  "<p>{{Ansprechpartner.briefanrede}}</p>",
  "<p>hiermit möchten wir höflich an unser Angebot <strong>{{Dokument.nummer}}</strong> erinnern, das wir Ihnen bereits zugesandt haben.</p>",
  "<p>Gerne stehen wir für Rückfragen zur Verfügung und freuen uns auf Ihre Rückmeldung.</p>",
  "<p>Mit freundlichen Grüßen</p>",
  "{{Signatur}}",
].join("");

export function listGdEmailVorlagen(typ?: GdEmailVorlageTyp): Promise<GdEmailVorlage[]> {
  const params = new URLSearchParams();
  if (typ) params.set("typ", typ);
  const query = params.toString();
  return api.get<GdEmailVorlage[]>(`/dokumente/email-vorlagen${query ? `?${query}` : ""}`);
}

export function saveGdEmailVorlage(
  typ: GdEmailVorlageTyp,
  payload: { subject: string; body_html: string },
): Promise<GdEmailVorlage> {
  return api.put<GdEmailVorlage>(`/dokumente/email-vorlagen/${typ}`, payload);
}

export function deleteGdEmailVorlage(typ: GdEmailVorlageTyp): Promise<{ ok: boolean }> {
  return api.del<{ ok: boolean }>(`/dokumente/email-vorlagen/${typ}`);
}
